var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorSeacrhIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7292 13.3333H14.7746L14.4363 13.0183C15.8863 11.385 16.6354 9.15666 16.2246 6.78833C15.6567 3.545 12.8534 0.954997 9.47002 0.558331C4.35877 -0.0483359 0.0571069 4.105 0.68544 9.04C1.09627 12.3067 3.77877 15.0133 7.13794 15.5617C9.59086 15.9583 11.8988 15.235 13.5904 13.835L13.9167 14.1617V15.0833L19.0521 20.0417C19.5475 20.52 20.3571 20.52 20.8525 20.0417C21.3479 19.5633 21.3479 18.7817 20.8525 18.3033L15.7292 13.3333ZM8.47919 13.3333C5.47044 13.3333 3.04169 10.9883 3.04169 8.08333C3.04169 5.17833 5.47044 2.83333 8.47919 2.83333C11.4879 2.83333 13.9167 5.17833 13.9167 8.08333C13.9167 10.9883 11.4879 13.3333 8.47919 13.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorSeacrhIcon);
export default __webpack_public_path__ + "static/media/VectorSeacrhIcon.2d03f477684e66ac6ea9b442109f4379.svg";
export { ForwardRef as ReactComponent };